angular.module('ihestiaMenuLeftNavbar', [
  'ihestiaRestServicesBase',
  'ihestia-menu-templates-app'
]);